import { Pipe, PipeTransform } from '@angular/core';
import { Expertise } from '../../models/expertise';

@Pipe({
	name: 'filterExpertiseByName'
})
export class FilterExpertiseByNamePipe implements PipeTransform {
	transform(expertise: Expertise[], filter: string): Expertise[] {
		if (
			!expertise ||
			!filter ||
			expertise === null ||
			filter === null ||
			filter === ''
		) {
			return expertise;
		}

		return expertise.filter((expertise: Expertise) => {
			if (expertise.name) {
				// TODO: add lastName too
				return expertise.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
